{
  "resourceType": "Medication",
  "id": "eLSmw4.Hohw6Y.tKyg5VnVWVvLacWgC3KbiczHeBt0ESst-Uin6cMNAflUagk47IB3",
  "code": {
    "coding": [
      { "system": "urn:oid:2.16.840.1.113883.6.253", "code": "11708" },
      { "system": "urn:oid:2.16.840.1.113883.6.68", "code": "79992001202010" },
      { "system": "urn:oid:2.16.840.1.113883.6.162", "code": "06573" },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "1901"
      },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "8591"
      },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "9863"
      },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "114202"
      },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "847630"
      },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "1008377"
      }
    ],
    "text": "lactated Ringer's infusion"
  },
  "form": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.0.1.7.4.698288.310",
        "code": "SOLN",
        "display": "solution"
      }
    ],
    "text": "solution"
  },
  "ingredient": [
    {
      "itemCodeableConcept": {
        "coding": [
          { "system": "urn:oid:2.16.840.1.113883.6.253", "code": "11708" },
          {
            "system": "urn:oid:2.16.840.1.113883.6.68",
            "code": "79992001202010"
          },
          { "system": "urn:oid:2.16.840.1.113883.6.162", "code": "06573" },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "1901"
          },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "8591"
          },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "9863"
          },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "114202"
          },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "847630"
          },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "1008377"
          }
        ],
        "text": "lactated Ringer's infusion"
      }
    }
  ]
}
